import useSWR from "swr";
import { listShapes } from "./service";
import { UseFilterShapesModel } from "./types";

const useFilterShapes = (): UseFilterShapesModel => {
  const { data, error, isLoading, mutate } = useSWR(
    `/scoring/mda/filters/shapes`,
    () => listShapes(),
  );

  return {
    data,
    isLoading,
    error,
    mutate,
  };
};

export default useFilterShapes;
